const NotificationTypeEnum = Object.freeze({
    // GENERAL
    DAILY_NOTIFICATION_REMINDER: 'DAILY_NOTIFICATION_REMINDER',
    // INVESTOR
    INVESTOR_ACCOUNT_AUTHORISED_INVESTOR: 'INVESTOR_ACCOUNT_AUTHORISED_INVESTOR',
    INVESTOR_MEDIA_CREATED_INVESTOR: 'INVESTOR_MEDIA_CREATED_INVESTOR',
    INVESTOR_MEDIA_CREATED_MULTIPLE_INVESTOR: 'INVESTOR_MEDIA_CREATED_MULTIPLE_INVESTOR',
    PROPOSAL_COMPLETED_INVESTOR: 'PROPOSAL_COMPLETED_INVESTOR',
    PROPOSAL_CREATED_INVESTOR: 'PROPOSAL_CREATED_INVESTOR',
    PROPOSAL_STATUS_UPDATED_INVESTOR: 'PROPOSAL_STATUS_UPDATED_INVESTOR',
    // PRIMARY_CONTACT
    INVESTOR_ACCOUNT_AUTHORISED_PRIMARY_CONTACT: 'INVESTOR_ACCOUNT_AUTHORISED_PRIMARY_CONTACT',
    INVESTOR_MEDIA_CREATED_MULTIPLE_PRIMARY_CONTACT: 'INVESTOR_MEDIA_CREATED_MULTIPLE_PRIMARY_CONTACT',
    INVESTOR_MEDIA_CREATED_PRIMARY_CONTACT: 'INVESTOR_MEDIA_CREATED_PRIMARY_CONTACT',
    PROPOSAL_COMPLETED_PRIMARY_CONTACT: 'PROPOSAL_COMPLETED_PRIMARY_CONTACT',
    PROPOSAL_CREATED_PRIMARY_CONTACT: 'PROPOSAL_CREATED_PRIMARY_CONTACT',
    PROPOSAL_STATUS_UPDATED_PRIMARY_CONTACT: 'PROPOSAL_STATUS_UPDATED_PRIMARY_CONTACT',
    SHORTLIST_NEEDS_ADVISER_FEES_PRIMARY_CONTACT: 'SHORTLIST_NEEDS_ADVISER_FEES_PRIMARY_CONTACT',
    // ADVISER
    INVESTOR_ACCOUNT_AUTHORISED_ADVISER: 'INVESTOR_ACCOUNT_AUTHORISED_ADVISER',
    INVESTOR_MEDIA_CREATED_ADVISER: 'INVESTOR_MEDIA_CREATED_ADVISER',
    INVESTOR_MEDIA_CREATED_MULTIPLE_ADVISER: 'INVESTOR_MEDIA_CREATED_MULTIPLE_ADVISER',
    PROPOSAL_COMPLETED_ADVISER: 'PROPOSAL_COMPLETED_ADVISER',
    PROPOSAL_CREATED_ADVISER: 'PROPOSAL_CREATED_ADVISER',
    PROPOSAL_STATUS_UPDATED_ADVISER: 'PROPOSAL_STATUS_UPDATED_ADVISER',
    SHORTLIST_NEEDS_ADVISER_FEES_ADVISER: 'SHORTLIST_NEEDS_ADVISER_FEES_ADVISER',
    // PROVIDER
    PROPOSAL_COMPLETED_PROVIDER: 'PROPOSAL_COMPLETED_PROVIDER',
    PROPOSAL_CREATED_PROVIDER: 'PROPOSAL_CREATED_PROVIDER',
    PROPOSAL_STATUS_UPDATED_PROVIDER: 'PROPOSAL_STATUS_UPDATED_PROVIDER',
    // FUND_MANAGER
    PROPOSAL_COMPLETED_FUND_MANAGER: 'PROPOSAL_COMPLETED_FUND_MANAGER',
    PROPOSAL_CREATED_FUND_MANAGER: 'PROPOSAL_CREATED_FUND_MANAGER',
    PROPOSAL_STATUS_UPDATED_FUND_MANAGER: 'PROPOSAL_STATUS_UPDATED_FUND_MANAGER',
    // COMPANY
    PROPOSAL_COMPLETED_COMPANY: 'PROPOSAL_COMPLETED_COMPANY',
    PROPOSAL_CREATED_COMPANY: 'PROPOSAL_CREATED_COMPANY',
    PROPOSAL_STATUS_UPDATED_COMPANY: 'PROPOSAL_STATUS_UPDATED_COMPANY'
});

export default NotificationTypeEnum;
